import { render, staticRenderFns } from "./defaultWithoutSidebar.vue?vue&type=template&id=710f351c&scoped=true"
import script from "./defaultWithoutSidebar.vue?vue&type=script&lang=js"
export * from "./defaultWithoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./defaultWithoutSidebar.vue?vue&type=style&index=0&id=710f351c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f351c",
  null
  
)

export default component.exports